'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

ProgressService=class ProgressService extends BaseService{
constructor(){
super();

this._currentProgress={};
}

get currentProgress(){
return this._currentProgress;
}

updateCurrentProgress(updatedProgress){
_.assign(this._currentProgress,updatedProgress);
}};


module.exports=ProgressService;
//# sourceMappingURL=progressService.js.map
